// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import wysiwyg from "vue-wysiwyg";
import "element-ui/lib/theme-chalk/index.css";
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
import axios from "axios";
import VeeValidate from "vee-validate";
import vSelect from "vue-select";
import VueVisible from "vue-visible";
import vueDebounce from 'vue-debounce'
import {
    SweetModal,
    SweetModalTab
} from "sweet-modal-vue";
import Vuex from "vuex";
import VModal from "vue-js-modal";
import {
    LocationPicker
} from "vue2-location-picker";
import VueSignaturePad from "vue-signature-pad";
import VueTelInput from "vue-tel-input";

import DatePicker from "vue2-datepicker";
import * as VueGoogleMaps from "vue2-google-maps";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import VueOtpInput from "@bachdgvn/vue-otp-input";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueRouterBackButton from "vue-router-back-button";
import store from "./store";
import InputTag from "vue-input-tag";
import VueTextareaAutosize from "vue-textarea-autosize";
import VueAWN from "vue-awesome-notifications";
import "vue-awesome-notifications/dist/styles/style.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueObserveVisibility from "vue-observe-visibility";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import VueApexCharts from "vue-apexcharts";
import fullscreen from "vue-fullscreen";
import ProgressBar from "vue-simple-progress";
import vueFilterPrettyBytes from "vue-filter-pretty-bytes";
import VueCircle from "vue2-circle-progress";
import Toasted from 'vue-toasted';
import globals from './components/globals';
// Firebase
import firebase from 'firebase/app';
require("firebase/messaging");
import Calendar from 'v-calendar/lib/components/calendar.umd'
import VDatePicker from 'v-calendar/lib/components/date-picker.umd'
import PopoverRow from 'v-calendar/lib/components/popover-row.umd.min'
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import VueWysiwyg from '@mycure/vue-wysiwyg';
import Avatar from 'vue-avatar'

Vue.use(fullscreen);

am4core.useTheme(am4themes_animated);

let options = {
    durations: {
        success: 2000,
        warning: 4000,
        info: 2000,
        alert: 2000,
    },
    position: "top-right",
    animationDuration: 200,
    labels: {
        success: "",
        alert: "",
    },
    icons: {
        enabled: true,
    },
};

var VueCookie = require("vue-cookie");
var VueUploadComponent = require('vue-upload-component');
// Tell Vue to use the plugin
//Vue.use(Toasted);
Vue.use(VueWysiwyg);
Vue.use(Toasted, {singleton: true});
Vue.use(VueCookie);
Vue.use(VModal);
Vue.use(firebase);
Vue.use(VeeValidate);
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(SweetModal);
Vue.use(SweetModalTab);
// Vue.use(axios);
Vue.use(VueVisible);
Vue.use(vueDebounce);
Vue.use(VueSignaturePad);
Vue.use(vueFilterPrettyBytes);
Vue.use(Avatar)
Vue.component("progress-bar", ProgressBar);
Vue.component('file-upload', VueUploadComponent)
Vue.config.productionTip = false;
locale.use(lang);
// Change URL based on Release for Production or Test
Vue.prototype.$serverUrl = globals.CRM_API;
// Vue.prototype.$serverUrl = "http://139.162.59.167:5000";
// Vue.prototype.$serverUrl = "https://crmapis.digicollect.com";
var token = Vue.cookie.get("Token");
Vue.prototype.$http = axios.create({
    baseURL: Vue.prototype.$serverUrl,
    headers: {
        Authorization: token,
        "Content-Type": "application/json",
        // withCredentials: true
    },
});


Vue.use(LocationPicker, {
    installComponents: false, // If true, create it globally
});
Vue.component("vue-tel-input", VueTelInput);
Vue.component("vue-phone-number-input", VuePhoneNumberInput);
Vue.use(VuePhoneNumberInput);
Vue.use(VueTelInput);
Vue.component("date-picker", DatePicker);
Vue.component("v-select", vSelect);
Vue.component("input-tag", InputTag);
Vue.use(VueTextareaAutosize);
Vue.use(VueAWN, options);
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY",
        libraries: "places", // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
});
// Vue.component('google-map', VueGoogleMaps.Map);
// Vue.component('google-marker', VueGoogleMaps.Marker);
Vue.component("v-otp-input", VueOtpInput);
Vue.use(VueSweetalert2);
Vue.use(VueRouterBackButton, {
    router
});
Vue.use(wysiwyg, {});
Vue.component("v-select", vSelect);
Vue.component("multiselect", Multiselect);
Vue.use(VueObserveVisibility);
Vue.component("apexchart", VueApexCharts);
Vue.component("vue-circle", VueCircle);
Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', VDatePicker)
Vue.component(PopoverRow)
Vue.use(VuejsDialog);

import {
    EventBus
} from "./components/eventBus/nav-bar-event.js";

if (VueCookie.get('Token')) {
    Vue.prototype.$http.interceptors.response.use(undefined, err => {
        // console.log(err.response);
        if (err.response.status == '403') {
            if(err.response.data.error == 'Permission Doesnot Exist') {
                EventBus.$emit('user_permissions_refresh_api_call')
                sessionStorage.setItem("error",err.response.data.reason)
                return Promise.reject(err);
            } else {
                if(err.response.config.url == globals.EXPENSE_API+'/expenses/list_expense') {
                    sessionStorage.setItem("error",err.response.data.reason)
                    return Promise.reject(err);
                } else {
                    VueCookie.delete("Token", {
                        domain: "digicollect.com",
                    });
                    var res = document.cookie;
                    var multiple = res.split(";");
                    for (var i = 0; i < multiple.length; i++) {
                        var key = multiple[i].split("=");
                        document.cookie = key[0] + " =; expires = Thu, 01 Jan 1970 00:00:00 UTC";
                    }
                    setTimeout(() => {
                        window.location.href = globals.CRM_URL + '/login';
                    }, 500);
                }
            }
        } else {
            sessionStorage.setItem("error",err.response.data.reason)
            return Promise.reject(err);
        }
    })
}

Vue.toasted.register(
    'error',
    message => {
        return message || 'Oops.. Something Went Wrong..'
    }, {
        type: 'error',
        position: 'top-center',
        duration: 2000,
        className: 'error_snack',
        closeOnSwipe: false,
        fullWidth: false,
        theme: 'toasted-primary',
        color: '#000000'
    }
)

new Vue({
    el: "#app",
    router,
    store,
    components: {
        App,
        SweetModal,
        SweetModalTab,
        LocationPicker,
    },
    template: "<App/>",
    data() {
        return {
            loggedIn: false,
        };
    },
});


// WEBPACK FOOTER //
// ./src/main.js